import { IEventForm } from 'domain/feature/hub/company/events/FormWrapper/constants'
import { v4 as uuidv4 } from 'uuid'

export const eventForm: IEventForm[] = [
  {
    id: 'generalConfig',
    name: 'Configurações Gerais',
    content: [
      {
        id: 'isInPerson',
        label: 'Evento Presencial?',
        description: 'Campo Obrigatório',
        type: 'checkbox',
        value: true,
        path: '',
        isDeleted: false,
        isRequired: true,
        positiveLabel: 'Evento Presencial',
        negativeLabel: 'Evento Virtual',
        dataCy: 'isInPersonInput'
      },
      {
        id: 'title',
        label: 'Nome',
        type: 'text',
        value: '',
        description: 'Campo Obrigatório',
        path: '',
        isDeleted: false,
        isRequired: true,
        maxLength: 256,
        validations: [
          {
            type: 'required',
            stage: 'save'
          },
          {
            type: 'maxLength',
            param: 256,
            stage: 'save'
          },
          {
            type: 'minLength',
            param: 4,
            stage: 'save'
          },
          {
            type: 'letterRequired',
            stage: 'all'
          }
        ],
        dataCy: 'eventTitleInput'
      },
      {
        id: 'description',
        label: 'Descrição',
        type: 'texteditor',
        value: '',
        path: '',
        maxLength: 5000,
        isDeleted: false,
        dataCy: 'descriptionInput'
      },
      {
        id: 'website',
        label: 'Site Oficial do Evento',
        type: 'url',
        value: null,
        path: '',
        isDeleted: false,
        validations: [
          {
            type: 'pattern',
            stage: 'save'
          }
        ],
        dataCy: 'websiteInput'
      },
      {
        id: 'coverImage',
        acceptedFile: 'image/*',
        recommendedFormat: '256x104px',
        maxSize: '5 MB',
        description: 'Selecione uma imagem para ser exibida no Market Place. O tamanho ideal é de 256px X 104px',
        label: 'Imagem de Capa',
        type: 'uploadImage',
        isDeleted: false,
        path: '',
        removed: [],
        archive: {
          id: '',
          path: null,
          isDeleted: true,
          name: null,
          size: null,
          mimetype: null,
          extension: null,
          type: null,
          content: null,
          sourceFile: null
        },
        dataCy: 'addimagePath'
      },
      {
        id: 'homePageSlider',
        acceptedFile: 'image/*',
        recommendedFormat: '1120x240px',
        maxSize: '5 MB',
        label: 'Imagem do Evento',
        description:
          'Selecione uma imagem para ser exibida no detalhamento do evento. O tamanho ideal é de 1120px X 240px',
        type: 'uploadImage',
        isDeleted: false,
        path: '',
        removed: [],
        archive: {
          id: '',
          path: null,
          isDeleted: true,
          name: null,
          size: null,
          mimetype: null,
          extension: null,
          type: null,
          content: null,
          sourceFile: null
        },
        dataCy: 'addHomePageSlider'
      },
      {
        id: 'supportFiles',
        maxSize: '50 MB',
        label: 'Documentos de Apoio',
        description: 'Selecione arquivos que serão importantes para entenderem melhor seu evento',
        type: 'multiFile',
        value: null,
        path: '',
        isDeleted: false,
        removed: [],
        archives: [],
        dataCy: 'addSupportFiles'
      },
      {
        id: 'startDate',
        label: 'Data de Início',
        type: 'datePicker',
        value: null,
        path: '',
        minDate: null,
        maxDate: null,
        isDeleted: false,
        isRequired: true,
        validations: [
          {
            type: 'required',
            stage: 'launch'
          }
        ],
        dataCy: 'startDateInput'
      },
      {
        id: 'endDate',
        label: 'Data de termino',
        type: 'datePicker',
        value: null,
        path: '',
        minDate: null,
        maxDate: null,
        isRequired: true,
        isDeleted: false,
        validations: [
          {
            type: 'required',
            stage: 'launch'
          }
        ],
        dataCy: 'endDateInput'
      },
      {
        id: 'startTime',
        label: 'Horário de Início',
        type: 'timePicker',
        value: null,
        path: '',
        isDeleted: false,
        isRequired: true,
        validations: [
          {
            type: 'required',
            stage: 'launch'
          }
        ],
        dataCy: 'startTimeInput'
      },
      {
        id: 'endTime',
        label: 'Horário de termino',
        type: 'timePicker',
        value: null,
        path: '',
        isDeleted: false,
        isRequired: true,
        validations: [
          {
            type: 'required',
            stage: 'launch'
          }
        ],
        dataCy: 'endTimeInput'
      },
      {
        id: 'isPaid',
        label: 'Evento Pago?',
        description: 'Campo Obrigatório',
        type: 'checkbox',
        value: undefined,
        path: '',
        isDeleted: false,
        isRequired: true,
        positiveLabel: 'Evento Pago',
        negativeLabel: 'Evento Gratuito',
        dataCy: 'isPaidInput'
      },
      {
        id: 'ticketDescription',
        label: 'Descrição do Ingresso',
        type: 'texteditor',
        value: '',
        path: '',
        maxLength: 5000,
        isDeleted: false,
        dataCy: 'ticketDescriptionInput'
      },
      {
        id: 'isActive',
        label: 'Visibilidade do Evento',
        description: 'Campo Obrigatório',
        type: 'activeCheckbox',
        value: undefined,
        path: '',
        isDeleted: false,
        isRequired: true,
        positiveLabel: 'Público, o evento será exibido na vitrine do site da Zing, acessível a todos.',
        negativeLabel: 'Privado, somente quem tiver o link poderá acessar o evento.',
        dataCy: 'isActiveInput'
      }
    ]
  },
  {
    id: 'addressConfig',
    name: 'Localização do Evento',
    content: [
      {
        id: `${String(uuidv4())}_idScreen`,
        name: 'Localização do Evento',
        type: 'addressForm',
        content: {
          id: `${String(uuidv4())}_idAddress`,
          fields: [
            {
              id: 'name',
              label: 'Nome do local',
              type: 'text',
              value: '',
              path: '',
              isDeleted: false,
              isRequired: true,
              maxLength: 256,
              validations: [
                {
                  type: 'required',
                  stage: 'launch'
                },
                {
                  type: 'maxLength',
                  param: 140,
                  stage: 'save'
                },
                {
                  type: 'minLength',
                  param: 4,
                  stage: 'launch'
                },
                {
                  type: 'letterRequired',
                  stage: 'all'
                }
              ],
              dataCy: 'addressNameInput'
            },
            {
              id: 'addressZipCode',
              label: 'CEP',
              type: 'text',
              value: '',
              path: '',
              isDeleted: false,
              isRequired: true,
              validations: [
                {
                  type: 'required',
                  stage: 'launch'
                }
              ],
              dataCy: 'addressZipCodeInput'
            },
            {
              id: 'addressLineOne',
              label: 'Endereço',
              type: 'text',
              value: '',
              path: '',
              isDeleted: false,
              isRequired: true,
              maxLength: 256,
              validations: [
                {
                  type: 'required',
                  stage: 'launch'
                }
              ],
              dataCy: 'addressLineOneInput'
            },
            {
              id: 'addressNumber',
              label: 'Número',
              type: 'number',
              value: '',
              path: '',
              isDeleted: false,
              isRequired: true,
              validations: [
                {
                  type: 'required',
                  stage: 'launch'
                }
              ],
              dataCy: 'addressNumberInput'
            },
            {
              id: 'addressLineTwo',
              label: 'Complemento',
              type: 'text',
              value: '',
              path: '',
              isDeleted: false,
              isRequired: false,
              maxLength: 256,
              validations: [],
              dataCy: 'addressLineTwoInput'
            },
            {
              id: 'addressNeighborhood',
              label: 'Bairro',
              type: 'text',
              value: '',
              path: '',
              isDeleted: false,
              isRequired: true,
              maxLength: 64,
              validations: [
                {
                  type: 'required',
                  stage: 'launch'
                }
              ],
              dataCy: 'addressNeighborhoodInput'
            },
            {
              id: 'addressCity',
              label: 'Cidade',
              type: 'text',
              value: '',
              path: '',
              isDeleted: false,
              isRequired: true,
              maxLength: 64,
              validations: [
                {
                  type: 'required',
                  stage: 'launch'
                }
              ],
              dataCy: 'addressCityInput'
            },
            {
              id: 'addressState',
              label: 'Estado',
              type: 'text',
              value: '',
              path: '',
              isDeleted: false,
              isRequired: true,
              maxLength: 2,
              validations: [
                {
                  type: 'required',
                  stage: 'launch'
                }
              ],
              dataCy: 'addressStateInput'
            }
          ]
        }
      }
    ]
  }
]
